/**
 * C2C 聊天相关 API
 */
import request from '../request'
import type { ApiResponse } from '../types'
import type {
  ChatInitRequest,
  ChatInitData,
  ChatHistoryRequest,
  ChatHistoryData,
  ChatBriefRequest,
} from './types'

/**
 * 初始化聊天室信息
 * @description 包含最近的消息、成员信息、已读状态等
 */
export function chatInitApi(data: ChatInitRequest): Promise<ApiResponse<ChatInitData>> {
  return request.post('/chat/init', data)
}

/**
 * 获取历史聊天记录
 * @description 用于上滑加载更多历史消息
 */
export function chatHistoryApi(data: ChatHistoryRequest): Promise<ApiResponse<ChatHistoryData>> {
  return request.post('/chat/history', data)
}
/**
 * 获取一次性票据
 * @description 用于 WebSocket 连接认证，会读取用户自己的 session_id 然后返回票据
 */
export function chatTicketApi(): Promise<ApiResponse<{ ticket: string }>> {
  return request.get('/chat/ticket')
}
/**
 * 订单简略信息
 */
export function chatBriefApi(data: ChatBriefRequest): Promise<
  ApiResponse<{
    order: {
      status: number
      expires_at: number
      reported: boolean
      version: number
    }
  }>
> {
  return request.get('/chat/brief', { params: data })
}

/** 上传交易凭证 */
export function chatUploadProofApi(
  file: File,
  session_id: string,
): Promise<ApiResponse<{ url: string }>> {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('session_id', session_id)
  return request.post('/chat/upload-proof', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
